import { Modal } from 'antd';
import { CustomImage } from './index';
import modalClose from '@src/assets/icons/icon-modal-close.svg';
import modalError from '@src/assets/icons/icon-modal-error.svg';
import modalSuccess from '@src/assets/icons/icon-modal-success.svg';
import modalWarning from '@src/assets/icons/icon-modal-warning.svg';
import iconBilgiSvg from '@src/assets/icons/icon-bilgi.svg';
import '@src/styles/components/dialog.scss';
import Text from './Text';
import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';

let customModal = Modal;

export const CustomDialogProvider = () => {
  const [modal, contextHolder] = Modal.useModal();

  customModal = modal;

  return <>{contextHolder}</>;
};


export const Header = ({
  title,
  closeModal,
  type,
  icon,
  closeIcon,
  customWarnIcon,
  headerTransparent = false,
}) => {

  return (
    <div
      className="dialog-header"
      style={{ backgroundColor: headerTransparent ? 'transparent' : '#efefef' }}
    >
      <div className={'title-content'}>
        {icon && <CustomImage className={`image-${type}`} src={icon} />}
        <div className="title">{title}</div>
      </div>
      {closeIcon && (
        <CustomImage
          data-testid="close-modal"
          className="close-image"
          src={modalClose}
          onClick={closeModal}
        />
      )}
    </div>
  );

};
Header.propTypes = {
  title: PropTypes.string,
  closeModal: PropTypes.func,
  type: PropTypes.string,
  icon: PropTypes.any,
  closeIcon: PropTypes.any,
  customWarnIcon: PropTypes.any,
  headerTransparent: PropTypes.any,
};

const Content = ({
  message,
  htmlContent,
  onCancel,
  headerTransparent = false,
  nonPadding = false,
}) => {
  const contentRef = useRef(null);

  useEffect(() => {
    if (htmlContent && contentRef.current) {
      const cancelButton = contentRef.current.querySelector('.utts-cancel-button');
      const okButton = contentRef.current.querySelector('.utts-ok-button');
      const cancelErrorButton = contentRef.current.querySelector('.utts-error-cancel-button');
      const okErrorButton = contentRef.current.querySelector('.utts-error-ok-button');

      const handleCancelClick = () => {
        onCancel?.();
      };

      if (cancelButton) {
        cancelButton.addEventListener('click', handleCancelClick);
      }

      if (okButton) {
        setTimeout(() => {
          okButton.addEventListener('click', handleCancelClick);
        }, 500);
      }

      if (cancelErrorButton) {
        cancelErrorButton.addEventListener('click', handleCancelClick);
      }

      if (okErrorButton) {
        setTimeout(() => {
          okErrorButton.addEventListener('click', handleCancelClick);
        }, 500);
      }

      return () => {
        if (cancelButton) {
          cancelButton.removeEventListener('click', handleCancelClick);
        }
        if (okButton) {
          setTimeout(() => {
            okButton.removeEventListener('click', handleCancelClick);
          }, 500);
        }
        if (cancelErrorButton) {
          cancelErrorButton.removeEventListener('click', handleCancelClick);
        }
        if (okErrorButton) {
          setTimeout(() => {
            okErrorButton.removeEventListener('click', handleCancelClick);
          }, 500);
        }
      };

    }
  }, [htmlContent, onCancel]);

  if (htmlContent) {
    return (

<div
        className="dialog-content"
        style={{
          paddingLeft: nonPadding ? 0 : 24,
          paddingRight: nonPadding ? 0 : 24,
          paddingTop: headerTransparent ? 10 : 24,
        }}
        ref={contentRef}
      >

        <div className="message">{htmlContent}</div>
      </div>
    );
  }
  return (
    <div className={'dialog-content'}>
      <div className="message" dangerouslySetInnerHTML={{ __html: message }} />
    </div>
  );
};


Content.propTypes = {
  message: PropTypes.any,
  htmlContent: PropTypes.any,
  onCancel: PropTypes.func,
  headerTransparent: PropTypes.bool,
  nonPadding: PropTypes.bool,
};



export const errorDialog = ({
  title,
  message,
  onOk,
  okText,
  htmlContent,
  closeIcon = true,
  titleLeftIcon = 'error',
  className,
}) => {
  const modal = customModal.info({
    width: 503,
    title: (
      <Header
        title={title}
        type={'error'}
        closeModal={() => {
          modal?.destroy();
          onOk?.();
        }}
        icon={titleLeftIcon === 'error' ? modalError : modalWarning}
        closeIcon={closeIcon}
      />
    ),
    content: (
      <Content
        message={message}
        htmlContent={htmlContent}
        onCancel={() => {
          modal?.destroy();
        }}
      />
    ),
    icon: false,
    className: `custom-dialog ${className}`,
    okText: okText || <Text t="okBtn" />,
    autoFocusButton: 'ok',
    keyboard: false,
    onOk: () => {
      modal?.destroy();
      onOk?.();
    },
  });

  return modal;
};
export const successDialog = ({ title, message, onOk, okText, htmlContent, closeIcon = true }) => {
  const modal = customModal.info({
    width: 503,
    title: (
      <Header
        title={title}
        type={'success'}
        closeModal={() => {
          modal?.destroy();
          onOk?.();
        }}
        icon={modalSuccess}
        closeIcon={closeIcon}
      />
    ),
    content: <Content message={message} htmlContent={htmlContent} />,
    icon: false,
    className: 'custom-dialog',
    okText: okText || <Text t="okBtn" />,
    autoFocusButton: 'ok',
    keyboard: false,
    onOk: () => {
      modal?.destroy();
      onOk?.();
    },
  });

  return modal;
};

export const warningDialog = ({
  title,
  message,
  onOk,
  okText,
  htmlContent,
  closeIcon = true,
  onCancel,
  cancelText,
  className,
  okButtonProps,

customWarnIcon = false,
  width = 503,
  notWarnIcon = false,
  headerTransparent = false,

nonPadding = false,

}) => {
  let iconElement;
  if (notWarnIcon) {
    iconElement = null;
  } else if (customWarnIcon) {
    iconElement = iconBilgiSvg;
  } else {
    iconElement = modalWarning;
  }

  const modal = customModal.info({
    width: width,
    title: (
      <Header
        title={title}
        type={'warning'}
        closeModal={() => {
          modal?.destroy();
          onCancel?.();
        }}
        icon={iconElement}
        closeIcon={closeIcon}
        headerTransparent={headerTransparent}
      />
    ),
    content: (
      <Content
        message={message}
        htmlContent={htmlContent}
        onCancel={() => {
          modal?.destroy();
          onCancel?.();
        }}
        headerTransparent={headerTransparent}
        nonPadding={nonPadding}
      />
    ),

icon: false,
    className: `custom-dialog ${className}`,
    okText: okText || <Text t="okBtn" />,
    autoFocusButton: 'ok',
    keyboard: false,
    onOk: () => {
      modal?.destroy();
      onOk?.();
    },
    onCancel: () => {
      modal?.destroy();
      onCancel?.();
    },
    okButtonProps: okButtonProps,
  });

  return modal;
};

export const confirmDialog = ({
  title,
  message,
  onOk,
  onCancel,
  okText,
  okCancel = true,
  cancelText,
  htmlContent,
  closeIcon = true,
}) => {
  let modal;

  const closeModal = (e) => {
    modal?.destroy();
    onCancel?.(e);
  };

  modal = customModal.confirm({
    width: 503,
    title: (
      <Header
        title={title}
        type={'warning'}
        closeModal={closeModal}
        icon={modalWarning}
        closeIcon={closeIcon}
      />
    ),
    content: <Content message={message} htmlContent={htmlContent} />,
    icon: false,
    className: 'custom-dialog',
    okText: okText || <Text t="okBtn" />,
    cancelText: cancelText || <Text t="giveUp" />,
    okCancel: okCancel,
    autoFocusButton: 'ok',
    keyboard: false,
    cancelButtonProps: { className: 'dialog-cancel-button' },
    okButtonProps: { className: 'dialog-ok-button' },
    onOk: () => onOk?.(),
    onCancel: () => onCancel?.(),
  });

  return modal;
};
